import Vue from "vue";

// "Instalează aplicația" (sidebar). Chrome/Edge/Samsung fire beforeinstallprompt when the app
// can be installed, possibly before the sidebar exists, so main.js calls watchInstallPrompt()
// first thing. iOS has no such event: the sidebar shows a "Partajare" hint instead.
let deferredPrompt = null;

const STANDALONE_MODES = ["standalone", "fullscreen", "minimal-ui", "window-controls-overlay"];

function runsInstalled() {
  return window.navigator.standalone === true
    || STANDALONE_MODES.some((mode) => window.matchMedia(`(display-mode: ${mode})`).matches);
}

export const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent)
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS reports a Mac

export const pwa = Vue.observable({ canPrompt: false, installed: runsInstalled() });

export function watchInstallPrompt() {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault(); // no mini-infobar; the sidebar entry calls prompt()
    deferredPrompt = event;
    pwa.canPrompt = true;
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    pwa.canPrompt = false;
    pwa.installed = true;
  });
}

// opens the browser's install dialog; an event can be prompted only once
export async function promptInstall() {
  const event = deferredPrompt;
  deferredPrompt = null;
  pwa.canPrompt = false;
  if (!event) return;
  event.prompt();
  const { outcome } = await event.userChoice;
  if (outcome === "accepted") pwa.installed = true;
}
